import { defineMessage } from 'services/localization';

export const messages = {
    deleteCompanySuccess: defineMessage('the_organisation_has_been_removed'),
};
